import { navigate, useLocation } from "@reach/router";
import { withPrefix } from "gatsby";
import React, {
  // useContext,
  useState,
} from "react";
import useAuth from "../../hooks/useAuth";
import useEventDetails from "../../hooks/useEventDetails";
import {
  getEventbriteUsersFromOrder,
  logInWithEmail,
  registerV2Alpha,
} from "../../services";
import { mergeWithInitialQuery } from "../../utils";
import EventbriteRegistration from "../forms/EventbriteRegistration";
import RegistrationForm from "../forms/registrationForm";

const RegistrationSection = () => {
  const { logInWithEmail } = useAuth();
  const [status, setStatus] = useState("ready");
  const [registrationError, setRegistrationError] = useState("");
  const location = useLocation();
  const { isAfterEvent, virtual } = useEventDetails();

  const handleOnRegistrationError = (error: string) => {
    setStatus("error");
    setRegistrationError(error.toString());
  };

  const handleOnOrderComplete = async (event: any) => {
    try {
      const query = mergeWithInitialQuery(location.search);
      const url = `${location.pathname}?${query}`;

      const eventBriteusers = await getEventbriteUsersFromOrder(event.orderId);
      const users = await Promise.all(
        eventBriteusers.map((user) => {
          return registerV2Alpha(user, { url });
        })
      );

      if (users.length > 0) {
        await logInWithEmail(eventBriteusers[0].email);
        setStatus("success");
        if (virtual) {
          navigate(withPrefix("/virtual/live"));
        }
      } else {
        throw new Error("failed to log user in");
      }
    } catch (error) {
      handleOnRegistrationError(error as string);
    }
  };

  return (
    <>
      {registrationError && (
        <div style={{ color: "red" }}>{registrationError}</div>
      )}
      {isAfterEvent ? (
        <RegistrationForm />
      ) : status !== "success" ? (
        <EventbriteRegistration onOrderComplete={handleOnOrderComplete} />
      ) : (
        <Confirmation />
      )}
    </>
  );
};

export default RegistrationSection;

const Confirmation = () => (
  <div style={{ marginTop: "40px" }}>
    <h2>
      Order Confirmed
      <br />
      <br />
      Thank you for registering.
    </h2>
    <p style={{ marginBottom: "35px" }}>
      You will receive an email confirmation with login information within 24
      hours. If you do not receive the email, please contact:{" "}
      <a href="mailto:events@scoopnewsgroup.com" target="_blank">
        events@scoopnewsgroup.com
      </a>
    </p>
  </div>
);
